import { WEB_URL, EXTENSIONS_WEB_URL } from "../constants";

/**
 * Checks whether given url is whitelisted and returns sanitized version of it
 * If it is not whitelisted or it is malicious; returns defaultUrl
 *
 * @param {String} url
 * @param {String} defaultUrl
 *
 * @returns {String} safe redirect url
 */
export default function getRedirectUrl(url: string | null | undefined, defaultUrl: string): string {
    if (!url) {
        return defaultUrl;
    }

    const whitelistedHostnames = [
        new URL(WEB_URL).hostname,
        new URL(location.origin).hostname,
        new URL(EXTENSIONS_WEB_URL).hostname
    ];

    try {
        const constructedURL = new URL(url, location.origin);
        if (whitelistedHostnames.includes(constructedURL.hostname)) {
            return url;
        }

        return defaultUrl;
    } catch (err) {
        // It is not a valid url
        return defaultUrl;
    }
}
